import { useGetFileSubmissionRecipientGroups } from '@/app/roleHooks';
import FileSubmissionForm from '@/components/MantineFileManager/btn/FileSubmissionForm';
import { useUserHasSomePermissions } from '@/shared/auth/useUserAffectations';
import { useIsXs } from '@/shared/utils/mediaQuery-utils';
import { ActionIcon, Button, Tooltip } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconUpload } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

const FileSubmissionBtn = () => {
  const { t } = useTranslate();
  const isXs = useIsXs();
  const { result: canSubmitFiles, isLoading } = useUserHasSomePermissions([
    'deposit-oru-drive-files',
  ]);

  const { data: recipientGroups = [] } = useGetFileSubmissionRecipientGroups();

  if (isLoading || !canSubmitFiles || recipientGroups.length === 0) {
    return null;
  }

  const handleSubmitClick = () => {
    modals.open({
      title: t('file.submission.title'),
      children: <FileSubmissionForm recipientGroups={recipientGroups} />,
      size: 'lg',
      fullScreen: isXs,
    });
  };

  return (
    <>
      <Tooltip label={t('file.submission.title')} withArrow>
        <ActionIcon
          onClick={handleSubmitClick}
          aria-label={t('file.submission.title')}
          hiddenFrom="sm"
          variant="light"
        >
          <IconUpload size={18} />
        </ActionIcon>
      </Tooltip>
      <Button
        leftSection={<IconUpload size={18} />}
        variant="light"
        onClick={handleSubmitClick}
        visibleFrom="sm"
      >
        {t('file.submission.title')}
      </Button>
    </>
  );
};

export default FileSubmissionBtn;
